import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {string} from 'yup'
import {executePost} from '../../../../configs/Kubuku'
import {PENGUNJUNGTERBANYAK, DOWNLOADPENGUNJUNG} from '../../../../api'
import * as XLSX from 'xlsx'
import clsx from 'clsx'
import {KTIcon} from '../../../helpers'
import {Spinner, Row, Col, Button} from 'react-bootstrap'

type DataItem = {
  id_mitra: string
  logo: string
  nama: string
  kota: string
  total_pengunjung: string
}

type Data = {
  id_mitra: string
  nama: string
  kota: string
  total_pengunjung: string
}

type Props = {
  bulanAwal: string
  bulanAkhir: string
  tahunAwal: string
  tahunAkhir: string
  idKota: string
  idJenjang: string
  periode: string
  periodeAwal: string
  periodeAkhir: string
  kota: string
  jenjang: string
  className: string
  tabelPengunjungTerbanyak: DataItem[]
  loading: boolean
  svgIcon: string
  iconClass?: string
}

const TablesWidgetPengunjungTerbanyak: React.FC<Props> = ({
  className,
  tabelPengunjungTerbanyak,
  loading,
  svgIcon,
  iconClass,
  bulanAwal,
  bulanAkhir,
  tahunAwal,
  tahunAkhir,
  idJenjang,
  idKota,
  periode,
  periodeAwal,
  periodeAkhir,
  kota,
  jenjang,
}) => {
  const [downloadUrl, setDownloadUrl] = useState<Data[]>([])

  const getDownloadPengunjung = async () => {
    try {
      const formData = new FormData()
      formData.append('id_kota', idKota)
      formData.append('id_tipe', idJenjang)
      formData.append('jenis_periode', periode)

      formData.append('bln_awal', periodeAwal)
      formData.append('bln_akhir', periodeAkhir)
      formData.append('thn_awal', tahunAwal)
      formData.append('thn_akhir', tahunAkhir)
      const response = await executePost(DOWNLOADPENGUNJUNG, formData)
      const dataResponse = response?.data
      setDownloadUrl(dataResponse)
    } catch (error) {
      console.error('Terjadi kesalahan', error)
    }
  }

  useEffect(() => {
    getDownloadPengunjung()
  }, [idKota, idJenjang, periode, periodeAwal, periodeAkhir, tahunAwal, tahunAkhir])

  const handleDownloadClick = () => {
    // Convert data to uppercase headers
    const uppercaseData = downloadUrl.map((item) => ({
      ID_MITRA: item.id_mitra,
      NAMA: item.nama,
      KOTA: item.kota,
      JUMLAH_PENGUNJUNG: Number(item.total_pengunjung).toLocaleString('id-ID'),
    }))

    // Convert the data to worksheet
    const ws = XLSX.utils.json_to_sheet(uppercaseData)

    // Create a new workbook
    const wb = XLSX.utils.book_new()

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    // Save the workbook as an Excel file
    XLSX.writeFile(wb, `Jumlah Pengunjung Terbanyak Di ${kota === '' ? 'Semua Kota' : kota}, ${jenjang === '' ? 'Semua Jenjang' : 'jenjang  ' + jenjang} (Periode ${bulanAwal} ${tahunAwal} - ${bulanAkhir} ${tahunAkhir}).xlsx`)
  }
  
  

  if (loading) {
    return (
      <div className={`card ${className}`}>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1 text-center'>
              <Spinner animation='border' />
            </span>
          </h3>
        </div>
      </div>
    )
  }
  if (!tabelPengunjungTerbanyak || tabelPengunjungTerbanyak.length === 0) {
    return (
      <div className={`card ${className}`}>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <div className='alert alert-danger text-center' role='alert'>
              TIDAK ADA DATA
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='w-25px'>No</th>
                <th className='min-w-140px'>Perpustakaan</th>
                <th className='min-w-120px'>Jumlah Pengunjung</th>
              </tr>
            </thead>
            <tbody>
              {tabelPengunjungTerbanyak.map((item, index) => (
                <tr key={item.id_mitra}>
                  <td>
                    <div className='form-check form-check-sm form-check-custom form-check-solid text-center'>
                      {index + 1}
                    </div>
                  </td>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='symbol symbol-45px me-5'>
                        <img src={item.logo} alt='' />
                      </div>
                      <div className='d-flex justify-content-start flex-column'>
                        <div className='text-dark fw-bold fs-6'>
                          {item.nama} <br />
                          <span className='fw-normal'>{item.kota}</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className='text-dark fw-bold d-block fs-6 text-center'>
                      {Number(item.total_pengunjung).toLocaleString('id-ID')}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Row>
            <Col></Col>
            <Col style={{marginLeft: '110px',  marginTop: '30px'}}>
              <div>
                <Button onClick={handleDownloadClick} className='btn btn-success'>
                  Download Excel{'   '}
                  <KTIcon
                    iconName={svgIcon || ''}
                    className={clsx(iconClass, 'fs-2hx ms-n1 flex-grow-1')}
                  />
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default TablesWidgetPengunjungTerbanyak
